"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTool = void 0;
/**
 * returns the tool name starting from the hostname
 * @param hostname
 */
function getTool(hostname) {
    const separatorIndex = hostname.indexOf('.');
    return separatorIndex !== -1 ? hostname.slice(0, separatorIndex) : hostname;
}
exports.getTool = getTool;
